import React from 'react'
import term from '../../../assets/term.svg'
export default function Politique() {
  return (
    <div>
      <div className="container  row">
        <div className="col-lg-4 mx-auto flex-col flex-wrap">
          <div className='my-5'>
            <h2 className='text-xl font-bold d-inline'>Conditions d'utilisations de la plateforme de </h2><a href="http://" className='navbar-brand'>havoo</a>
            <p className='text-gray text-sm'>
              Havoo est une plateforme de mise en relation des demandeurs de
              services avec ceux qui en proposent ,par le billet de cet
              application web ,nous vous offrons le meilleur service possible en
              terme d'efficacite et autres...
            </p>
          </div>
          <div className="text-gray-500">
            <div className='text-xl text-black font-bold'>
              <h2>Services</h2>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Repellendus accusamus eveniet quasi deserunt, necessitatibus vel.
              Qui dicta dolore neque obcaecati nemo. Recusandae, cumque eaque
              pariatur itaque ducimus voluptates vero aspernatur?
            </p>
          </div>

          <div className="text-gray-500 my-2">
            <div className='text-xl text-black font-bold'>
              <h2>Profil</h2>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Repellendus accusamus eveniet quasi deserunt, necessitatibus vel.
              Qui dicta dolore neque obcaecati nemo. Recusandae, cumque eaque
              pariatur itaque ducimus voluptates vero aspernatur?
            </p>
          </div>

          <div className="text-gray-500 my-2">
            <div className='text-xl text-black font-bold'>
              <h2>L'inscription</h2>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Repellendus accusamus eveniet quasi deserunt, necessitatibus vel.
              Qui dicta dolore neque obcaecati nemo. Recusandae, cumque eaque
              pariatur itaque ducimus voluptates vero aspernatur?
            </p>
          </div>

          <div className="text-gray-500 my-2">
            <div className='text-xl text-black font-bold'>
              <h2>Services</h2>
            </div>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Repellendus accusamus eveniet quasi deserunt, necessitatibus vel.
              Qui dicta dolore neque obcaecati nemo. Recusandae, cumque eaque
              pariatur itaque ducimus voluptates vero aspernatur?
            </p>
          </div>
        </div>
        <div className='col-lg-4 mt-10 fixed right-0 d-none d-lg-block'>
<img src={term} alt="" />
        </div>
      </div>
    </div>
  )
}
